export const NO_BUSINESS_ID = 'none';
